import getInObject from '@insight/toolkit-utils/lib/helpers/getInObject';
import setInObject from '@insight/toolkit-utils/lib/helpers/setInObject';

export const hasAnyError = (errors) =>
  Object.keys(errors).some((key) => {
    const value = errors[key];
    if (value && typeof value === 'object') {
      return hasAnyError(value);
    }
    return typeof value !== 'undefined';
  });

export const hasSyncErrors = (formState) =>
  !!(formState.error || hasAnyError(formState.errors));

export const markAllFieldsTouched = ({ fields }) => {
  Object.keys(fields).forEach((key) => {
    fields[key].touched = true;
  });
};

export const changeValue = (state, name, mutate) => {
  const before = getInObject(state.formState.values, name);
  const after = mutate(before);
  state.formState.values =
    setInObject(state.formState.values, name, after) || {};
};

export const renameField = (state, from, to) => {
  if (state.fields[from]) {
    state.fields = {
      ...state.fields,
      [to]: {
        ...state.fields[from],
        lastFieldState: undefined,
        name: to,
      },
    };
    delete state.fields[from];
    state.fieldSubscribers = {
      ...state.fieldSubscribers,
      [to]: state.fieldSubscribers[from],
    };

    delete state.fieldSubscribers[from];
    const value = getInObject(state.formState.values, from);
    state.formState.values =
      setInObject(state.formState.values, from, undefined) || {};
    state.formState.values = setInObject(state.formState.values, to, value);
    delete state.lastFormState;
  }
};
